import { map } from 'rxjs/operators';
import { ContactInformationService } from './../../../services/contact-information/contact-information.service';
import { SubSink } from 'subsink';
import { PlatformService } from './../../../services/platform/platform.service';
import { ModalController, ToastController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.page.html',
  styleUrls: ['./contact-info.page.scss'],
})
export class ContactInfoPage implements OnInit {
  states: any;
  stateCities: any;
  isMobileDevice: boolean;
  contactInfoForm: FormGroup;
  subscription = new SubSink();
  disabledState = false;

  showSpinner: boolean = false;

  response_message: string = '';
  hasResponseError: boolean = false;

  constructor(
    private fb: FormBuilder,
    private platform: PlatformService,
    private modalCtrl: ModalController,
    private toast: ToastController,
    private contactInfoService: ContactInformationService
  ) {
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    this.readyContactInfoForm();
    this.getStates();
    this.getContactInfoData();
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  readyContactInfoForm() {
    this.contactInfoForm = this.fb.group({
      contact_person_name: ['', [Validators.required, Validators.pattern(/\S+/)]],
      contact_person_email: ['', [Validators.required, Validators.pattern('^[^@]+@([-\\w]+\\.)+[A-Za-z]{2,4}$')]],
      contact_person_phone: ['', [Validators.required, Validators.pattern('^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$')]],
      street_address: ['', Validators.pattern(/\S+/)],
      state: [null, Validators.required],
      city: [null, Validators.required],
      zip_code: ['', [Validators.required, Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')]],
      lat: [null, [Validators.required, Validators.pattern('^[-+]?[0-9]\\d*(\\.\\d+)?$')]],
      long: [null, [Validators.required, Validators.pattern('^[-+]?[0-9]\\d*(\\.\\d+)?$')]],
    });
  }

  get contact_person_name() {
    return this.contactInfoForm.get('contact_person_name');
  }

  get contact_person_email() {
    return this.contactInfoForm.get('contact_person_email');
  }

  get contact_person_phone() {
    return this.contactInfoForm.get('contact_person_phone');
  }
  get street_address() {
    return this.contactInfoForm.get('street_address');
  }

  get state() {
    return this.contactInfoForm.get('state');
  }

  get city() {
    return this.contactInfoForm.get('city');
  }

  get zip_code() {
    return this.contactInfoForm.get('zip_code');
  }

  get lat() {
    return this.contactInfoForm.get('lat');
  }

  get long() {
    return this.contactInfoForm.get('long');
  }


  readyFormData(res: any) {
    this.contactInfoForm.patchValue({
      contact_person_name: res.contact_person_name ?? '',
      contact_person_email: res.contact_person_email ?? '',
      contact_person_phone: res.contact_person_phone ?? '',
      street_address: res.street_address ?? '',
      state: res.state ?? null,
      city: res.city ?? null,
      zip_code: res.zip_code ?? '',
      lat: res.lat ?? null,
      long: res.long ?? null,
    });
    this.getStateCitiesPatch();
  }

  getStates() {
    this.subscription.sink = this.contactInfoService.getStates().subscribe(
      (states: any[]) => {
        this.states = states['data'];
      },
      (error) => console.log(error)
    );
  }

  getStateCities() {
    this.contactInfoForm.get('city').setValue(null);
    this.contactInfoForm.get('lat').setValue(null);
    this.contactInfoForm.get('long').setValue(null);
    var state_id = this.contactInfoForm.value.state;
    this.subscription.sink = this.contactInfoService.getStateCities(state_id).subscribe(
      (stateCities: any[]) => {
        this.stateCities = stateCities['data'];
      },
      (error) => console.log(error)
    );
  }

  getStateCitiesPatch() {
    var state_id = this.contactInfoForm.value.state;
    this.subscription.sink = this.contactInfoService.getStateCities(state_id).subscribe(
      (stateCities: any[]) => {
        this.stateCities = stateCities['data'];
      },
      (error) => console.log(error)
    );
  }

  getContactInfoData() {
    this.subscription.sink = this.contactInfoService
      .getContactInfo()
      .subscribe(
        (res_contactInfo: any) => {
          console.log("get contact info ===> ", res_contactInfo);
          this.readyFormData(res_contactInfo);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  updateContactInfo() {
    this.showSpinner = true;
    let contactInfo = this.contactInfoForm.value;
    // console.log('form data ---------->', contactInfo);

    this.subscription.sink = this.contactInfoService
      .addContactInfo(contactInfo)
      .subscribe(
        (res: any) => {
          this.showSpinner = false;
          // console.log('add contact response ==> ', res);

          let newLat = res.data[0].lat;
          let newLong= res.data[0].long;
          this.updateProfileStorage(newLat, newLong);

          this.hasResponseError = false;
          this.response_message = res.message;
          this.presentSuccessToast(this.response_message);
        },
        (err: any) => {
          this.showSpinner = false;
          // console.log('Error ==> ', err);
          this.hasResponseError = true;
          this.response_message = "An error occurred adding your Contact information, please try again later.";
          this.presentErrorToast(this.response_message);
        }
      );

  }

  updateProfileStorage(newLat, newLong) {
    let userProfile = JSON.parse(localStorage.getItem('user_profile'));
    userProfile.lat = newLat;
    userProfile.long = newLong;
    localStorage.setItem('user_profile', JSON.stringify(userProfile));
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  closeModal() {
    return this.modalCtrl.dismiss();
  }

  getCityLatLong(){
    this.contactInfoForm.get('lat').setValue(null);
    this.contactInfoForm.get('long').setValue(null);
    let city = this.contactInfoForm.value.city;
    this.stateCities.map((item) => {
      if(item.id == city){
        this.contactInfoForm.get('lat').setValue(item.lat);
        this.contactInfoForm.get('long').setValue(item.long);
      }
    });
  }

}
